import i18next from "i18next";

const LANG_KEY: { [key: string]: string } = {
  en: "en",
  zh: "zh-cn",
  de: "de-de",
};

const DOMAIN: { [key: string]: string } = {
  en: "com",
  zh: "cn",
  de: "com",
};

export const getOutsideUrl = (target: string) => {
  const urlDomain = ["en", "de"].includes(i18next.language)
    ? LANG_KEY[i18next.language]
    : "en";
  switch (target) {
    case "contact":
      return `https://www.trelleborg.${DOMAIN[i18next.language]}/${
        LANG_KEY[i18next.language]
      }/anti-vibration-solutions/contact`;
    case "terms":
      return `https://www.trelleborg.com/${urlDomain}/anti-vibration-solutions/about-us/terms-and-conditions`;
    case "privacy":
      return `https://www.trelleborg.${DOMAIN[i18next.language]}/${
        LANG_KEY[i18next.language]
      }/anti-vibration-solutions/privacy-notice`;
    case "doc":
      return `https://www.trelleborg.com/${urlDomain}/anti-vibration-solutions/media/document-center`;
    default:
      return `https://www.trelleborg.${DOMAIN[i18next.language]}/${
        LANG_KEY[i18next.language]
      }/anti-vibration-solutions`;
  }
};
